import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changeOrderState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`orderState`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#orderstate"
          }}>{`OrderState`}</a>{` - Required`}</li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#order-state-changed"
        }}>{`OrderStateChanged`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      